// @ts-nocheck
class PortfolioGrid extends HTMLElement {
  constructor() {
    super();
    this.filterButtons = this.querySelectorAll('.portfolio-grid__filter-btn');
    this.cards = this.querySelectorAll('.portfolio-grid__card');
    this.countEl = this.querySelector('.portfolio-grid__count-number');
    this.activeFilter = 'all';
    this._handleFilterClick = this.handleFilterClick.bind(this);
  }

  connectedCallback() {
    this.filterButtons.forEach((btn) => {
      btn.addEventListener('click', this._handleFilterClick);
    });
  }

  disconnectedCallback() {
    this.filterButtons.forEach((btn) => {
      btn.removeEventListener('click', this._handleFilterClick);
    });
  }

  handleFilterClick(e) {
    const btn = e.currentTarget;
    const filter = btn.dataset.filter;

    if (filter === this.activeFilter) return;
    this.activeFilter = filter;

    this.filterButtons.forEach((b) => {
      const isActive = b === btn;
      b.classList.toggle('portfolio-grid__filter-btn--active', isActive);
      b.setAttribute('aria-selected', isActive ? 'true' : 'false');
    });

    let visibleCount = 0;

    this.cards.forEach((card) => {
      const tags = card.dataset.tags ? card.dataset.tags.split(' ') : [];
      const show = filter === 'all' || tags.includes(filter);
      card.classList.toggle('portfolio-grid__card--hidden', !show);
      if (show) visibleCount++;
    });

    if (this.countEl) {
      this.countEl.textContent = String(visibleCount);
    }
  }
}

customElements.define('portfolio-grid', PortfolioGrid);
